import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError, AxiosResponse } from 'axios'
import { constructApiEndpoint, httpPost } from '@school/common/common-utils/helpers/httpClient'
import { RootState } from '@school/store/store'
import { ATTENDANCEGARPH } from '@school/common/common-utils/constants/slice-constants'
import { AttendanceChartParams, ChartPoint } from '@school/schemas/typeInterface'


// Async thunk for attendance
export const attendanceChart = createAsyncThunk(
  ATTENDANCEGARPH,
  async ({ payload, reportName }: AttendanceChartParams, { rejectWithValue }) => {
    try {
      const url = ATTENDANCEGARPH + '?reportName=' + reportName
      const endpoint = constructApiEndpoint(url, {})
      const response: AxiosResponse<ChartPoint[]> = await httpPost(endpoint, payload)
      const updatedData =
        response?.data?.map((item) => ({
          ...item,
          date: !item?.date ? Number(item.month) : item?.date,
        })) || []
      return updatedData
    } catch (err: unknown) {
      if (err instanceof AxiosError) {
        const axiosError = err as AxiosError<{ message?: string[] | string }>
        const apiMessage = axiosError.response?.data?.message
        const message = Array.isArray(apiMessage)
          ? apiMessage[0]
          : apiMessage || axiosError.message || 'Chart fetch failed'
        return rejectWithValue(message)
      }

      return rejectWithValue('An unexpected error occurred')
    }
  },
)

interface AuthState {
  data: ChartPoint[] | null
  loading: boolean
  error: string | null
}

const initialState: AuthState = {
  data: null,
  loading: false,
  error: null,
}

// Create slice
const chartSlice = createSlice({
  name: 'chart',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(attendanceChart.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(attendanceChart.fulfilled, (state, action) => {
        state.loading = false
        state.data = action?.payload
      })
      .addCase(attendanceChart.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
         state.data = []
      })
  },
})

// Export actions and reducer
export const selectChart = (state: RootState) => state.chart.data

export default chartSlice.reducer
